//Some shortcuts for functions
function nextSlide() {
  Reveal.right();
}

function prevSlide() {
  Reveal.left();
}

function downSlide() {
  Reveal.down();
}

function upSlide() {
  Reveal.up();
}

function nextHide() {
  $('#si-next').hide();
}

function nextShow() {
  $('#si-next').show();
}

function backHide() {
  $('#si-back').hide();
}

function backShow() {
  $('#si-back').show();
}

function jumpToSlide(n) {
  Reveal.slide(n - 1);
}

function jumpToId(id) {
  var num = slides[id]['slideNumber'];
  Reveal.slide(num - 1);
}

function lock($element) {
  $element.addClass('noEvents');
  $element.attr('disabled', 'disabled');
}

function unlock($element) {
  $element.removeClass('noEvents');
  $element.removeAttr('disabled');
}

function completeSlide() {
  if (slides[globalVar.curSlide]['include']) {
    slideCompletion[globalVar.curSlide] = 1;
  }
  // console.log(slideCompletion)
}

function customNavStyle(navElem, styleClass, html) {
  var elem = $('#si-' + navElem);
  var initialHTML = elem.html();
  var curSlide = slides[globalVar.curSlide];

  if (html) elem.html(html);

  elem.addClass(styleClass);

  curSlide.onExitAction = (function() {
    var originalOnExit = curSlide.onExitAction;
    return function() {
      if (originalOnExit) originalOnExit.apply(this);
      elem.html(initialHTML);
      elem.removeClass(styleClass);
    };
  })();
}

////////////*Feature:idebehold///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

//the holy cheatfunction!!!
function devMode() {
  // Cheat code. See Doom.

  $('body').addClass('dev-mode');
  console.log('GOD MODE!');
  $('#guidelines').show();

  $(document).keyup(function(e) {
    // 'g' key toggles grid lines
    if (e.which == 71) {
      if ($('#guidelines').css('display') != 'none') {
        $('#guidelines').hide();
      } else {
        $('#guidelines').show();
      }
    }

    // shift + arrow keys allow navigation through horizontal and vertical slides
    if (e.shiftKey && e.which == 37) {
      Reveal.left();
    }
    if (e.shiftKey && e.which == 39) {
      Reveal.right();
    }
    if (e.shiftKey && e.which == 38) {
      Reveal.up();
    }
    if (e.shiftKey && e.which == 40) {
      Reveal.down();
    }

    // 'j' key reveals positive feedback
    if (e.which == 74) {
      $('#' + globalVar.curSlide)
        .find('.si-positive')
        .addClass('si-current-modal')
        .show();
      $('#' + globalVar.curSlide)
        .find('.si-negative')
        .removeClass('si-current-modal')
        .hide();
      $('#' + globalVar.curSlide)
        .find('.si-negative-final')
        .removeClass('si-current-modal')
        .hide();
    }
    //  'k' key reveals negative feedback 1
    if (e.which == 75) {
      $('#' + globalVar.curSlide)
        .find('.si-positive')
        .removeClass('si-current-modal')
        .hide();
      $('#' + globalVar.curSlide)
        .find('.si-negative')
        .addClass('si-current-modal')
        .show();
      $('#' + globalVar.curSlide)
        .find('.si-negative-final')
        .removeClass('si-current-modal')
        .hide();
    }
    // 'l' key reveals negative feedback 2
    if (e.which == 76) {
      $('#' + globalVar.curSlide)
        .find('.si-positive')
        .removeClass('si-current-modal')
        .hide();
      $('#' + globalVar.curSlide)
        .find('.si-negative')
        .removeClass('si-current-modal')
        .hide();
      $('#' + globalVar.curSlide)
        .find('.si-negative-final')
        .addClass('si-current-modal')
        .show();
    }
    //  ';' key hides all feedbacks
    if (e.which == 186) {
      $('#' + globalVar.curSlide)
        .find('.si-positive')
        .removeClass('si-current-modal')
        .hide();
      $('#' + globalVar.curSlide)
        .find('.si-negative')
        .removeClass('si-current-modal')
        .hide();
      $('#' + globalVar.curSlide)
        .find('.si-negative-final')
        .removeClass('si-current-modal')
        .hide();
    }
  });
}
